import { Box } from '@mui/material';
import {
  HeaderNavbar,
  SubscriptionGuard
} from 'modules';
import { Outlet } from 'react-router-dom';



export type CompanyLayoutProps = {};

export const CompanyLayout = (props: CompanyLayoutProps) => {
  return (
    <SubscriptionGuard.FC>
      <Box
        columnGap='1rem'
        paddingX='1.5rem'
      >
        <HeaderNavbar.FC />
        <Box
          height='calc(100vh - 120px)'
          width='100%'
        >
          <Outlet />
        </Box>
      </Box>
    </SubscriptionGuard.FC>
  );
};
